import { faMagnifyingGlass } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { SanityMapSection } from 'graphql-types';
import React, { useState } from 'react';
import PlacesAutocomplete, { geocodeByAddress, getLatLng } from 'react-places-autocomplete';
import Arrow from '../../../static/svg/arrow-down-orange.svg';
import { trads } from '../../constants/trads';
import { findTranslation } from '../../utils/findTranslation';
import { useMapContext } from '../context/mapContext';
import { usePageContext } from '../context/pageContext';
import { Expert } from '../section/MapSection';
import * as styles from './mapFilter.module.scss';

interface Props {
  expertiseList: string[];
  results: Expert[];
  isLoaded: boolean;
  section: SanityMapSection;
}

export const MapFilter: React.FC<Props> = ({ expertiseList, results, isLoaded, section }) => {
  const { expFilter, setExpFilter, filterInput, setFilterInput, setPanCoords, panCoords } =
    useMapContext();
  const [open, setOpen] = useState<boolean>(false);

  const { lang, defaultLang } = usePageContext();

  const filters = ['all'].concat(expertiseList);

  const handleSelect = (value: string, placeId: string, suggestion?: object) => {
    setFilterInput(value);
    geocodeByAddress(value)
      .then((results) => getLatLng(results[0]))
      .then((latLng) => {
        setPanCoords({ lat: latLng.lat, lng: latLng.lng });
      })
      .catch((error) => console.error('Error', error));
  };

  return (
    <div className={styles.wrapper}>
      <form
        name="filterForm"
        method="post"
        onSubmit={(e: any) => {
          e.preventDefault();
        }}
      >
        {isLoaded && (
          // @ts-ignore
          <PlacesAutocomplete
            value={filterInput}
            onChange={setFilterInput}
            onSelect={handleSelect}
            debounce={400}
            shouldFetchSuggestions={filterInput.length > 3}
          >
            {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => {
              return (
                <div>
                  <div className={styles.input}>
                    <input
                      {...getInputProps({
                        placeholder: `${findTranslation(
                          section?._rawLocationMapSection,
                          lang,
                          defaultLang,
                        )}`,
                        type: 'text',
                      })}
                    />
                    <FontAwesomeIcon icon={faMagnifyingGlass} />
                  </div>
                  <div className={styles.autocompleteDropdownContainer}>
                    {suggestions.map((suggestion, index) => {
                      return (
                        <div
                          {...getSuggestionItemProps(suggestion)}
                          className={styles.suggestion}
                          key={`suggestion-${index}`}
                        >
                          <span>{suggestion.description}</span>
                        </div>
                      );
                    })}
                  </div>
                </div>
              );
            }}
          </PlacesAutocomplete>
        )}

        <div
          className={`${styles.selectorWrapper} ${open && styles.icon}`}
          onClick={() => setOpen((e) => !e)}
        >
          {findTranslation(section?._rawTypeoftreatmentMapSection, lang, defaultLang)}
          <Arrow />
        </div>
        <div className={`${styles.dropDown} ${open && styles.visible}`}>
          {filters.map((item, index) => {
            const isAll = index === 0;
            const isEmpty = expFilter.length === 0;

            const elem = section.expertiseList?.find(
              (el) => findTranslation(el?._rawTitle, lang, defaultLang) === item,
            );
            const itemActive = expFilter.includes(elem?.key ?? '');

            const trad =
              item.toLowerCase() === 'all'
                ? trads.all[lang]
                : findTranslation(elem?._rawTitle, lang, defaultLang);
            const color = elem?.colorNav ?? '';

            if (!trad) return null;
            return (
              <div
                key={`item-${index}`}
                onClick={() => {
                  if (isAll) {
                    return isEmpty ? null : setExpFilter([]);
                  }

                  itemActive
                    ? setExpFilter(expFilter.filter((i) => i !== elem?.key))
                    : setExpFilter([...expFilter, elem?.key ?? '']);
                }}
                className={`${isAll && isEmpty && styles.active} ${itemActive && styles.active} ${
                  isAll && isEmpty && styles.noPointer
                }`}
                datatype={color}
              >
                {trad}
              </div>
            );
          })}
        </div>
      </form>
    </div>
  );
};
